/**
 * Network detail screens carried over from NMM (device chassis view, OLT, ONT with ACS management), restyled in the
 * Netxol One palette. Loaded on demand — they are large.
 */
import { lazy, Suspense, type ReactNode } from 'react';
import './nms.css';
import { t } from '@/i18n';

export const NmsDeviceDetail = lazy(() => import('./pages/DeviceDetailPage').then((m: any) => ({ default: m.DeviceDetailPage ?? m.default })));
export const NmsOltDetail = lazy(() => import('./pages/OltDetailPage').then((m: any) => ({ default: m.OltDetailPage ?? m.default })));
export const NmsOnuDetail = lazy(() => import('./pages/OnuDetailPage').then((m: any) => ({ default: m.OnuDetailPage ?? m.default })));

export function NmsPage({ children }: { children: ReactNode }) {
  return <div className="nms px-6 py-5"><Suspense fallback={<div className="py-16 text-center text-sm text-muted-foreground">{t('common.loading')}</div>}>{children}</Suspense></div>;
}
